import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Rating from '../rating/rating';
import FilterReviews from '../filter/Filter';
import './header.scss';

const Header = (props) => {
    const {
        toggleCollapsed,
        ratingFive,
        totalCount,
        title
    } = props;

    return (
        <header onClick={toggleCollapsed}>
            <h2>
                { title }
                {ratingFive && <Rating ratingFive={ratingFive} totalCount={totalCount}/>}
            </h2>
            <i className="ficon ficon-chevron-down"/>
            <FilterReviews fetchReviews={props.fetchReviews} type={props.type} lastReview={props.lastReview} pathFinderConfig={props.pathFinderConfig}/>
        </header>
    );
};

const mapStateToProps = (state) => {
    const isSeller = state.get('is_seller'),
        reviewsAsSeller = state.get('reviews_as_seller'),
        gigId = state.get('gig_id') || state.get('gigId'),
        isDoubleBlindFormat = state.get('is_double_blind_format');

    if (!isDoubleBlindFormat) {
        return {title: i18n.t('reviews.header.title')};
    }
    if (gigId) {
        return {title: i18n.t('reviews.header.gig')};
    }
    if (isSeller && reviewsAsSeller) {
        return {title: i18n.t('reviews.header.as_seller')};
    }

    return {title: i18n.t('reviews.header.as_buyer')};
};

Header.defaultProps = {
    toggleCollapsed: null
};

Header.propTypes = {
    title: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/reviews/header/header.js